import { type SeatProvisionStatus } from '@/utils/functions/selfService/types'

export const getCurrentProvisionStatus = (current: number, max: number): SeatProvisionStatus => {
  const noneSeats = max === 0
  const underProvisioned = current < max
  const overProvisioned = current > max
  const provisioned = current === max

  if (noneSeats) return 'none'
  if (overProvisioned) return 'overProvisioned'
  if (underProvisioned) return 'underProvisioned'
  if (provisioned) return 'provisioned'
  console.error('unexpected provision status', { current, max })
  throw new Error('unexpected provision status')
}
